export default __webpack_public_path__ + "static/media/CNo.38-3.76fa2c04.jpg";